import { useCallback, useRef, useState } from 'react';
import { useSelector } from '@betty/toolkit/state';
import { isTrackerVisible } from './useTracker.utils';
import { selectCommunityJackpotEvents } from '../../state/communityJackpot.slice';

const useTracker = () => {
  const [event] = useSelector(selectCommunityJackpotEvents);
  const [visible, setVisible] = useState(isTrackerVisible(event));
  const eventRef = useRef(event);

  eventRef.current = event;

  const onMilestoneHit = useCallback(() => {
    setVisible(isTrackerVisible(eventRef.current));
  }, []);

  return { visible, onMilestoneHit };
};

export default useTracker;
